import { useMemo } from 'react';
import getUrlParameter from '../../../utils/GetUrlParameter';
import * as queryString from 'query-string';
import { ListingType } from '../../../interfaces/interfaces';

/**
 * Custom hook to extract and parse all subscription-related URL parameters
 * Provides a centralized, type-safe way to access URL parameters used in subscription flows
 *
 * @returns Object containing all subscription-related URL parameters
 */
export const useSubscriptionParams = () => {
    return useMemo(() => {
        const parsedParams = queryString.parse(window?.location?.search);

        // Get listing type from query param, default to CNGFW
        const listingParam = getUrlParameter('listing') || parsedParams['listing'] as string;
        const listing: ListingType = (listingParam === 'AIRFM' || listingParam === 'CNGFW')
            ? listingParam as ListingType
            : 'CNGFW';

        return {
            // AWS Account Information
            accountId: getUrlParameter('acc-id') || '',

            // AWS Marketplace Parameters
            marketplaceToken: getUrlParameter('marketplace-token') || '',
            productId: getUrlParameter('product-id') || '',
            productCode: getUrlParameter('product-code') || '',
            agreementId: getUrlParameter('agreement-id') || '',

            // Subscription State
            accountStatus: getUrlParameter('link-state') || '',

            // Billing Association Code
            billingAssociationCode: parsedParams['BillingAssociationCode'] as string || '',

            // Product Listing Type
            listing,

            // All parsed parameters (useful for passing state to Okta)
            allParams: parsedParams,
        };
    }, []); // Empty deps array as URL params are read once on mount
};
